<template>
  <div
    class="property-card"
    @click="openProperty"
  >
    <div class="property-card__image lazy-image__wrap">
      <img
        class="lazy-image"
        :src="property.background_image"
        alt=""
      >
    </div>
    <div class="property-card__tags" />
    <div class="property-card__text">
      <div class="property-card__text-title">
        {{ property.name }}
      </div>
      <div class="property-card__text-group mb-3">
        {{ property.city }}, {{ property.state }}
      </div>
      <!-- TODO Price hidden for now because it was hard to get on backend. -->
      <div
        v-if="false"
        class="property-card__text-price"
      >
        <span class="font-weight-bold">$128</span> / month
      </div>
      <div
        class="property-card__text-description"
        v-html="property.general_info"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import { VANITY_WEB_URLS } from '../../constants'
import { lazyLoadingHack } from '../../mixins/lazyLoadingHack'

@Component({})
export default class PropertyCard extends Vue {
  @Prop({}) property: any

  domainAliases = {}

  mounted () {
    lazyLoadingHack()
    this.parseDomainAliases()
  }

  parseDomainAliases () {
    const { VUE_APP_DOMAIN_ALIASES } = process.env
    const aliases = VUE_APP_DOMAIN_ALIASES?.split(',') || []
    aliases.forEach((alias) => {
      const [vanityUrl, mainUrl, propertyId] = alias.split('>')
      this.domainAliases[propertyId] = {
        mainUrl,
        vanityUrl,
      }
    })
  }

  openProperty () {
    const domainAliase = this.domainAliases[this.property.id]
    const isMainPage = window.location.href.includes(domainAliase?.mainUrl)

    if (domainAliase && isMainPage) {
      window.open(`//${domainAliase.vanityUrl}`, '_blank')
      return
    }

    const route = this.$router.resolve({
      name: 'Property',
      params: { id: this.property.id },
    })

    window.open(route.href, '_blank')
  }
}
</script>

<style lang="scss">
  .property-card {
    cursor: pointer;

    &__image {
      position: relative;
      border-radius: 2px;
      overflow: hidden;
      &:after {
        content: "";
        display: block;
        padding-bottom: 65%;
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__text {
      padding: 1rem 0;

      &-description,
      &-group {
        font-size: 0.875rem;
        color: var(--v-textSecondary-base);
      }
      &-title {
        font-size: 1.25rem;
      }

      &-price {
        font-size: 0.875rem;
        font-weight: 300;
        margin-bottom: 0.5rem;
        color: var(--v-textSecondary-base);
      }

      &-description {
         display: block;
         display: -webkit-box;
         max-width: 100%;
         height: calc(1.2rem * 3);
         margin: 0 auto;
         font-size: 1rem;
         line-height: 1.25;
         line-clamp: 3;
         -webkit-line-clamp: 3;
         -webkit-box-orient: vertical;
         overflow: hidden;
         text-overflow: ellipsis;
      }
    }
  }
</style>
